import { useEffect } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _TrainingRequest } from "../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { MultiAccountanEditor } from "../../../../../editor/MultiAccountanEditor";
import { SelectFunctionalID } from "../../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { AccountEditor } from "../../../../../editor/AccountEditor";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOLCAP001 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};

    const { instance, bean, setBean, isMissing, validateForm, addRequiredFields } = useDataBean(_TrainingRequest);

    useEffect(() => {
        const requiredFields = ["TargetScopeType", "TrainingTopic", "Description", "Justification"];
        const targetScopeType = Number(bean.TargetScopeType);

        if (targetScopeType === 101) {
            requiredFields.push("IDLnFunctionalID");
        }

        if (targetScopeType === 102) {
            requiredFields.push("ListIDAccounts");
        }

        if (targetScopeType === 103) {
            requiredFields.push("IDAccount");
        }

        addRequiredFields(requiredFields);
    }, [bean.TargetScopeType])

    useEffect(() => {
        if (props?.IDTrainingRequest) {
            instance.getTrainingRequest(props?.IDTrainingRequest).then(
                (resp) => {
                    setBean(resp);
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props?.IDTrainingRequest])

    const getIDAccountValue = (value: any) => {
        return Number(typeof value === "object" ? value?.IDAccount : value);
    }

    const getListIDAccounts = (value: any): number[] => {
        const normalizeIDs = (list: any[]) => {
            return list
                .map(getIDAccountValue)
                .filter((id) => !Number.isNaN(id));
        }

        if (!value) return [];
        if (Array.isArray(value)) return normalizeIDs(value);

        if (typeof value === "string") {
            const cleanValue = value.trim();
            if (!cleanValue) return [];

            try {
                const parsedValue = JSON.parse(cleanValue);
                return Array.isArray(parsedValue) ? normalizeIDs(parsedValue) : [];
            } catch {
                return normalizeIDs(cleanValue.split(",").map((id) => id.trim()));
            }
        }

        return [];
    }

    const getTargetScopeName = (targetScopeType: number) => {
        const scopeType = Number(targetScopeType);

        if (scopeType === 101) return "Area Funcional";
        if (scopeType === 102) return "Usuarios Selectos";
        if (scopeType === 103) return "Unico Usuario";
        return "N/A";
    }

    const getTargetScopeDetail = (data: any) => {
        const scopeType = Number(data.TargetScopeType);

        if (scopeType === 101) return data.IDLnFunctionalIDName ?? data.FunctionalIDName ?? data.IDLnFunctionalID ?? "N/A";
        if (scopeType === 102) return getListIDAccounts(data.ListIDAccounts).join(", ") || "N/A";
        if (scopeType === 103) return data.IDAccountName ?? data.EntityName ?? data.IDAccount ?? "N/A";
        return "N/A";
    }

    const isTargetScopeMissing = () => {
        return Number(bean.TargetScopeType) === 102 && getListIDAccounts(bean.ListIDAccounts).length === 0;
    }

    const onExportMap = (data = bean) => {
        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Alcance de la Capacitacion": getTargetScopeName(data.TargetScopeType),
                "Detalle del Alcance": getTargetScopeDetail(data),
                "Tematica": data.TrainingTopic,
                "Descripcion": data.Description,
                "Justificacion": data.Justification,
            })
        );

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(data);
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(data);
        }
    }

    const updateData = () => {
        if (!validateForm() || isTargetScopeMissing()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        const data = {
            ...bean,
            State: 1,
        };

        instance.updateTrainingRequest(data).then(
            (resp) => {
                const updatedBean = resp ?? data;
                setBean(updatedBean);
                onExportMap(updatedBean);
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }

    const updateListIDAccounts = (listIDAccounts: number[]) => {
        setBean((prev: any) => ({
            ...prev,
            ListIDAccounts: listIDAccounts?.length ? JSON.stringify(listIDAccounts) : ""
        }));
    }

    return (
        <div className="row">

            {/* <PrintJson json={props} /> */}

            <div className="col-md-6">
                <label className={`${isMissing('TargetScopeType') ? 'has-error' : ''}`}>Alcance de la Capacitación</label>
                <select className="form-select" value={bean.TargetScopeType} onChange={(e) => { setBean({ ...bean, TargetScopeType: e.target.value ? Number(e.target.value) : null }) }}>
                    <option value="">...</option>
                    <option value="101">Area Funcional</option>
                    <option value="102">Usuarios Selectos</option>
                    <option value="103">Único Usuario</option>
                </select>
            </div>

            {bean.TargetScopeType &&
                <div className="col-md-6">
                    {Number(bean.TargetScopeType) === 101 &&
                        <>
                            <label className={`${isMissing('IDLnFunctionalID') ? 'has-error' : ''}`}>Area Funcional</label>
                            <SelectFunctionalID label=" " functionalIDLn={bean.IDLnFunctionalID} onChange={(e) => { setBean({ ...bean, IDLnFunctionalID: e.IDLn, IDLnFunctionalIDName: e.Name }) }} />
                        </>
                    }
                    {Number(bean.TargetScopeType) === 102 &&
                        <>
                            <label className={`${isMissing('ListIDAccounts') || isTargetScopeMissing() ? 'has-error' : ''}`}>Lista de Empleados</label>
                            <MultiAccountanEditor values={bean.ListIDAccounts} label=" " onChange={updateListIDAccounts} />
                        </>
                    }
                    {Number(bean.TargetScopeType) === 103 &&
                        <>
                            <label className={`${isMissing('IDAccount') ? 'has-error' : ''}`}>Usuario Seleccionado</label>
                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount, IDAccountName: e.EntityName }) }} />
                        </>
                    }
                </div>
            }

            <div className="col-md-12">
                <label className={`${isMissing('TrainingTopic') ? 'has-error' : ''}`}>Temática de la capacitación</label>
                <input type="text" className="form-control" value={bean.TrainingTopic} onChange={(e) => { setBean({ ...bean, TrainingTopic: e.target.value }) }} />
            </div>

            <div className="col-md-12">
                <label className={`fw-bold ${isMissing('Description') ? 'has-error' : ''}`}>Descripción de la Capacitación</label>
                <textarea
                    className="form-control mt-1"
                    rows={3}
                    value={bean.Description}
                    onChange={(e) =>
                        setBean(prev => ({ ...prev, Description: e.target.value }))
                    }
                />
            </div>
            <div className="col-md-12">
                <label className={`fw-bold ${isMissing('Justification') ? 'has-error' : ''}`}>Justificación</label>
                <textarea
                    className="form-control mt-1"
                    rows={3}
                    value={bean.Justification}
                    onChange={(e) =>
                        setBean(prev => ({ ...prev, Justification: e.target.value }))
                    }
                />
            </div>

            <div className="col-md-6">
                <BasicButton eventClick={() => { updateData() }} icon="ri-send-plane-line" useMargin children={"Solicitar"} />
            </div>
        </div>
    );
}
